import { useEffect, useState } from 'react'
import { ReactSVG } from 'react-svg'

import Input, { InputProps } from '@shared/ui/input'
import { useDebounce } from '@shared/uttils/useDebounce'

interface SearchProps extends InputProps {
  value: string;
  placeholder: string;
  handleChange: (val: string) => void;
  isInvalid?: boolean;
}

export default function Search (props: SearchProps) {
  const { value, placeholder, handleChange, ...rest } = props
  const [ internalValue, setInternalValue ] = useState(value)
  const debouncedValue = useDebounce(internalValue, 1500)

  useEffect(() => {
    setInternalValue(value)
  }, [ value ])

  useEffect(() => {
    handleChange(debouncedValue)
  }, [ debouncedValue, handleChange ])

  return (
    <Input
      placeholder={placeholder}
      value={internalValue}
      onChange={(e) => setInternalValue(e.target.value)}
      theme="grey"
      inputSize="large"
      startDecorator={<ReactSVG src="/icons/search.svg" wrapper="span" />}
      {...rest}
    />
  )
}
